import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { connect } from "react-redux";

import {
  setTicketsStats,
  fetchTicketsStats,
  addOpenedTickets,
  setLogins,
  addLogins,
  addClosedTickets,
  fetchDataResumeCash,
  setDataResumeCash,
  setOpenedTickets,
  fetchOpenedTickets,
  setCC,
  setVersionDB,
  setCCVehicles,
  updateClosedTickets,
  updateOpenedTickets,
  removeOpenedTicket,
  setClosedTickets,
  removeClosedTicket,
  setAppConfig,
  setInout,
  addInout,
  setSyncVersion,
  setTariffs,
  setCanEditTariffs,
  setReportEmails,
  setReportJobs,
} from "../store/data/actions";
import { getVersionedCollection } from "../utils/firestorePaths";

import { setDataCash, addDataCash, updateDataCash, removeDataCash } from "../store/cash/actions";
import { setCurrentCompany, setLicences } from "../store/companies/actions";
import {
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
  where,
  getDocs,
  getDoc,
  limit,
  limitToLast,
  startAfter,
  startAt,
  Timestamp,
} from "firebase/firestore";
import { firestore } from "../firebase";
import moment from "moment";
import "moment/locale/es";
import { isEqual } from "lodash";

import numeral from "numeral";
import { setCurrencySymbol, setCurrencyLocale, formatCurrency } from "../utils/formatCurrency";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function formatDate(date) {
  const pad = (n) => (n < 10 ? "0" + n : n);
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.000000`;
}

const ListenerDB = (props) => {
  const dispatch = useDispatch();
  const { currentCompany } = props;
  const previousCompanyData = useRef(null);
  const toastGraceRef = useRef(0);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);


  const [isBackground, setIsBackground] = useState(false);

  useEffect(() => {
    try {
      const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
          // Pausa todos los toasts cuando la página está en segundo plano
          // toast.pause(true);
          setIsBackground(true);
        } else {
          setIsBackground(false);
          toast.dismiss(); // Descarta todos los toasts acumulados al volver al primer plano
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);

      return () => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      };
    } catch (error) {
      alert("Error en ListenerDB: " + error);
    }
  }, []);

  /////////////// COMPANY DATA

  useEffect(() => {
    try {
      let unsubscribe;

      const fetchData = async () => {
        const userId = currentCompany.id;
        const usersRef = collection(firestore, "users");
        const userIdRef = doc(usersRef, userId);

        try {
          // Escucha cambios solo en el campo "company" del documento
          unsubscribe = onSnapshot(
            userIdRef,
            { fields: ["company"] },
            (docSnapshot) => {
              if (docSnapshot.exists()) {
                const companyData = docSnapshot.get("company");
                companyData.id = userId;
                if (!isEqual(companyData, previousCompanyData.current)) {
                  // Realiza las acciones que deseas hacer cuando el campo "company" cambie
                  dispatch(setCurrentCompany(companyData));
                  previousCompanyData.current = companyData;
                }
              }
            }
          );
        } catch (error) {
          console.error("Error al obtener datos:", error);
        }
      };

      fetchData();

      // Devuelve una función de limpieza para detener el listener cuando el componente se desmonte
      return () => {
        if (unsubscribe) {
          unsubscribe();
        }
      };
    } catch (error) {
      alert("Error en ListenerDB: " + error);
    }
  }, [props.currentCompany.id, dispatch]); // Asegúrate de agregar las dependencias necesarias

  useEffect(() => {
    try {
      let unsubscribe;

      const fetchData = () => {
        const userId = currentCompany.id;
        const usersRef = collection(firestore, "users");
        const userIdRef = doc(usersRef, userId);

        try {
          unsubscribe = onSnapshot(userIdRef, (docSnapshot) => {
            if (docSnapshot.exists()) {
              const userData = docSnapshot.data();
              // Intenta acceder directamente con get()

              // SYNC VERSION
              const sv = userData?.sync_version || 0;
              dispatch(setSyncVersion(sv));

              // VERSION: preferimos version_app (versión actual del cliente).
              // Fallback a version_db para clientes viejos que aún no la envían.
              const versionApp =
                userData?.app_config?.version_app ||
                userData?.app_config?.version_db ||
                "0.0.0";
              dispatch(setVersionDB(versionApp));

              const appConfig = userData?.app_config || {};
              setCurrencySymbol(appConfig.currency_symbol);
              setCurrencyLocale(currentCompany.country);
              dispatch(setAppConfig(appConfig));

              // Actualizar licencia en tiempo real
              const licence = userData?.licence ?? null;
              dispatch(setLicences({ [currentCompany.id]: licence }));

              // TICKETSTATS
              const rawStats = userData?.ticket_stats;
              const ticketsStats = Array.isArray(rawStats) ? rawStats : (rawStats?.stats || []);
              dispatch(setTicketsStats(ticketsStats));

              // TARIFFS (config de tarifas/precios enviada desde tc_qml)
              const tariffs = userData?.tariffs ?? null;
              dispatch(setTariffs(tariffs));

              // INFORMES: lista de emails verificados y jobs de envío
              const reportEmails = userData?.report_emails;
              dispatch(setReportEmails(Array.isArray(reportEmails) ? reportEmails : []));
              const reportJobs = userData?.report_jobs;
              dispatch(setReportJobs(reportJobs && typeof reportJobs === "object" ? reportJobs : {}));

              // // RESUME CASH
              // const resumeCashArray = userData?.resume_cash || [];
              // console.log("resumeCashArray", resumeCashArray);
              // if (resumeCashArray.array) {
              //   const jsonFormat = resumeCashArray.array
              //     .replace(/\(/g, "[") // Reemplaza "(" por "["
              //     .replace(/\)/g, "]") // Reemplaza ")" por "]"
              //     .replace(/'/g, '"'); // Reemplaza las comillas simples por comillas dobles
              //   const dataArray = JSON.parse(jsonFormat);
              //   let totalCash = 0;
              //   dataArray.forEach((element) => {
              //     totalCash += element[2];
              //   });
              //   dataArray.forEach((element) => {
              //     element[3] = parseInt((element[2] / totalCash) * 100);
              //   });
              //   dataArray.unshift([1, "TOTAL", totalCash, 100]);
              //   // Actualiza el estado de Redux con los datos
              //   dispatch(setDataResumeCash(dataArray));
              // } else {
              //   console.log("No hay datos de resume cash", resumeCashArray);
              // }
              // // dispatch({ type: UPDATE_RESUME_CASH_STATE, payload: dataArray });

              // RESUME CASH
              const resumeCashArray = userData?.resume_cash || [];

              console.log("resumeCashArray", resumeCashArray);

              // Asegurarse de que es un array antes de trabajar con él
              if (
                Array.isArray(resumeCashArray) &&
                resumeCashArray.length > 0
              ) {
                let totalCash = 0;

                resumeCashArray.forEach((element) => {
                  totalCash += element.amount; // Usar "amount" en lugar de "element[2]"
                });

                resumeCashArray.forEach((element) => {
                  element.percentage =
                    totalCash > 0
                      ? parseInt((element.amount / totalCash) * 100)
                      : 0;
                });

                // Agregar la fila "TOTAL"
                resumeCashArray.unshift({
                  id: 1,
                  type: "TOTAL",
                  amount: totalCash,
                  percentage: 100,
                });

                // Actualiza el estado de Redux con los datos
                dispatch(setDataResumeCash(resumeCashArray));
              } else {
                console.log("No hay datos de resume cash", resumeCashArray);
              }
            }
          });
        } catch (error) {
          console.log("Error fetching ticket stats:", error);
        }
      };

      fetchData();

      return () => {
        if (unsubscribe) {
          unsubscribe();
        }
        // Limpiar tariffs al cambiar de cliente — evita mostrar datos del
        // cliente anterior mientras se espera el primer snapshot del nuevo, y
        // oculta el menú Tarifario hasta que haya data confirmada.
        dispatch(setTariffs(null));
        // Misma lógica para informes.
        dispatch(setReportEmails([]));
        dispatch(setReportJobs({}));
        // Y para versión/appConfig: con datos residuales de la empresa
        // anterior, los gates de versión (CAEA y legacy) bloquearían un
        // instante a la empresa nueva atribuyéndole la versión de la vieja.
        // Con "0.0.0"/{} ambos gates hacen fail-open hasta el primer snapshot.
        dispatch(setVersionDB("0.0.0"));
        dispatch(setAppConfig({}));
      };
    } catch (error) {
      alert("Error en ListenerDB: " + error);
    }

    // No se retorna nada aquí
  }, [props.currentCompany.id, dispatch]);

  ///////////// PERMISO EDITAR TARIFARIO ///////////////////////////////
  // Lee users/{id}/auth buscando el doc con email == user actual.
  // Si ese doc tiene can_edit_tariffs === true, el dueño puede editar.
  //
  // Excepción: emails del equipo TicketControl tienen acceso global a
  // Gestión en cualquier cliente — sirve para evaluar/soportar sin
  // pedirle al dueño que les dé permiso manualmente en cada empresa.
  useEffect(() => {
    if (!currentCompany?.id) return;
    const user = JSON.parse(localStorage.getItem("authUser") || "null");
    if (!user?.email) {
      dispatch(setCanEditTariffs(false));
      return;
    }
    const TC_STAFF_EMAILS = ["ticketcontrol.latam@gmail.com"];
    if (TC_STAFF_EMAILS.includes(user.email)) {
      dispatch(setCanEditTariffs(true));
      return;
    }
    const authRef = collection(doc(firestore, "users", currentCompany.id), "auth");
    const q = query(authRef, where("email", "==", user.email));
    const unsubscribe = onSnapshot(
      q,
      (snap) => {
        let canEdit = false;
        snap.forEach((d) => {
          const data = d.data() || {};
          if (data.can_edit_tariffs === true) canEdit = true;
        });
        dispatch(setCanEditTariffs(canEdit));
      },
      (err) => {
        console.warn("Error al leer auth para permisos de tarifario:", err);
        dispatch(setCanEditTariffs(false));
      }
    );
    return () => {
      if (unsubscribe) unsubscribe();
      dispatch(setCanEditTariffs(false));
    };
  }, [props.currentCompany.id, dispatch]);

  ///////////// LOGINS /// SOLO TOMA EL ULTIMO LOGIN //////////////////////
  ///////////// LOGINS /// SOLO TOMA EL ULTIMO LOGIN //////////////////////
  useEffect(() => {
    try {
      let unsubscribe; // Declarar la variable en el ámbito superior
      const fetchData = async () => {
        const userId = currentCompany.id;
        const loginsRef = collection(doc(firestore, "users", userId), "logins");
        const q = query(loginsRef, orderBy("created", "desc"), limit(1));
        // Obtener documentos iniciales
        const initialQuerySnapshot = await getDocs(q);
        const initialDocuments = [];
        let last_doc = null;
        initialQuerySnapshot.forEach((doc) => {
          const docData = doc.data();
          if (last_doc == null) {
            last_doc = docData.created;
          }
          initialDocuments.push(docData);
        });

        dispatch(setLogins(initialDocuments));

        try {
          unsubscribe = onSnapshot(q, (snapshot) => {
            snapshot.docChanges().forEach((change) => {
              const loginData = change.doc.data();
              if (loginData.created > last_doc) {
                dispatch(addLogins(loginData));
                toast.info("Nuevo inicio de sesión: " + loginData.fullName);
              }
            });
          });
        } catch (error) {
          console.log("Error fetching logins:", error);
        }
      };

      fetchData();

      return () => {
        if (unsubscribe) {
          unsubscribe();
        }
      };
    } catch (error) {
      alert("Error en ListenerDB: " + error);
    }
  }, [props.currentCompany.id, dispatch]);

  ///////// TICKETS //////////////

  useEffect(() => {
    try {
      const ticketsRef = getVersionedCollection(
        currentCompany.id,
        "tickets",
        props.syncVersion
      );

      // Consulta para tickets abiertos
      const qOpen = query(
        ticketsRef,
        where("closed", "==", 0),
        orderBy("init_date", "desc")
      );

      // Listener para tickets abiertos
      let isInitialLoad = true;
      toastGraceRef.current = Date.now(); // Grace period: 15s sin toasts tras montar listener
      const unsubscribeOpen = onSnapshot(qOpen, (querySnapshot) => {
        if (isInitialLoad) {
          isInitialLoad = false;
          const initialDocuments = [];
          querySnapshot.forEach((doc) => {
            initialDocuments.push(doc.data());
          });
          dispatch(setOpenedTickets(initialDocuments));
        } else {
          const changes = querySnapshot.docChanges();
          let addedCount = 0;
          let closedCount = 0;

          // Dispatch de todas las acciones (siempre, sin importar toasts)
          changes.forEach((change) => {
            const ticket = change.doc.data();
            if (change.type === "added") {
              addedCount++;
              dispatch(addOpenedTickets(ticket));
            } else if (change.type === "modified") {
              if (ticket.closed === 1) {
                closedCount++;
                dispatch(removeOpenedTicket(ticket));
              } else {
                dispatch(updateOpenedTickets(ticket));
              }
            } else if (change.type === "removed") {
              closedCount++;
              dispatch(removeOpenedTicket(ticket));
            }
          });

          // Toasts: solo después del grace period (15s) para evitar spam en resync
          if (Date.now() - toastGraceRef.current > 15000) {
            if (addedCount > 2) {
              toast.info(`${addedCount} nuevos tickets abiertos`);
            } else {
              changes
                .filter((c) => c.type === "added")
                .forEach((c) =>
                  toast.info("Nuevo ticket abierto: #" + c.doc.data().plate)
                );
            }
            if (closedCount > 2) {
              toast.info(`${closedCount} tickets cerrados`);
            } else if (closedCount > 0) {
              changes
                .filter(
                  (c) =>
                    c.type === "removed" ||
                    (c.type === "modified" && c.doc.data().closed === 1)
                )
                .forEach((c) =>
                  toast.info("Ticket cerrado: #" + c.doc.data().plate)
                );
            }
          }
        }
      });


      // ////////////////////// Consulta para tickets cerrados
      // const qClosed = query(
      //   ticketsRef,
      //   where("closed", "==", 1),
      //   where("init_date", ">=", thirtyDaysAgoString),
      //   orderBy("init_date", "desc"),
      //   limit(isMobile ? 200 : 200)
      // );


      // // Listener para tickets cerrados
      // let isInitialLoadClosed = true;
      // const unsubscribeClosed = onSnapshot(qClosed, (querySnapshot) => {
      //   if (isInitialLoadClosed) {
      //     // Es la carga inicial
      //     isInitialLoadClosed = false;
      //     // Procesa los documentos iniciales sin mostrar toasts
      //     const initialDocuments2 = [];
      //     querySnapshot.forEach((doc) => {
      //       initialDocuments2.push(doc.data());
      //     });
      //     dispatch(setClosedTickets(initialDocuments2));
      //   } else {
      //     // Maneja los cambios en tiempo real
      //     querySnapshot.docChanges().forEach((change) => {
      //       const ticket = change.doc.data();
      //       if (change.type === "added") {
      //         // Nuevo ticket abierto después de la carga inicial
      //         toast.info("Ticket Cerrado: #" + ticket.plate);
      //         dispatch(addClosedTickets(ticket));
      //       } else if (change.type === "modified") {
      //         // Ticket abierto modificado
      //         dispatch(updateClosedTickets(ticket));
      //       } else if (change.type === "removed") {
      //         // Ticket abierto eliminado (posiblemente cerrado)
      //         dispatch(removeClosedTicket(ticket));
      //       }
      //     });
      //   }
      // });

      return () => {
        unsubscribeOpen();
        // unsubscribeClosed();
      };
    } catch (error) {
      alert("Error en ListenerDB: " + error);
    }
  }, [props.currentCompany.id, props.syncVersion]);

  /////// CC //////////////

  useEffect(() => {
    try {
      const ccRef = getVersionedCollection(currentCompany.id, "cc", props.syncVersion);
      const q = query(ccRef, orderBy("fullName", "asc"));

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const cc = [];
        querySnapshot.forEach((doc) => {
          const d = doc.data();
          if (d.closed == 0) cc.push(d);
        });

        dispatch(setCC(cc));
      });

      return () => {
        unsubscribe();
      };
    } catch (error) {
      alert("Error en ListenerDB: " + error);
    }
  }, [props.currentCompany.id, props.syncVersion, dispatch]);

  ///////// CC_VEHICLES //////////////

  useEffect(() => {
    try {
      const ccVehiclesRef = getVersionedCollection(
        currentCompany.id,
        "cc_vehicles",
        props.syncVersion
      );
      const q = query(ccVehiclesRef, orderBy("fullName", "asc"));

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const cc_vehicles = [];
        querySnapshot.forEach((doc) => {
          const d = doc.data();
          if (d.deleted == 0) cc_vehicles.push(d);
        });

        dispatch(setCCVehicles(cc_vehicles));
      });

      return () => {
        unsubscribe();
      };
    } catch (error) {
      alert("Error en ListenerDB: " + error);
    }
  }, [props.currentCompany.id, props.syncVersion, dispatch]);

  /// CASH ///////////////////////

  useEffect(() => {
    try {
      let unsubscribe; // Declarar la variable en el ámbito superior

      const fetchDocuments = async () => {
        dispatch(setDataCash([]));
        const cashRef = getVersionedCollection(
          props.currentCompany.id,
          "cash",
          props.syncVersion
        );

        // Obtener solo las últimas 30 sesiones init (limitToLast + asc)
        // usa el índice existente, sin leer TODOS los init docs
        const qInit = query(
          cashRef,
          where("type", "==", "init"),
          orderBy("date", "asc"),
          limitToLast(30)
        );
        const initSnapshot = await getDocs(qInit);

        if (initSnapshot.docs.length > 0) {
          // El primer doc del resultado asc-limitToLast es el más antiguo de los 10
          const oldestInitDoc = initSnapshot.docs[0];

          // Se pagina por FECHA, no por `id`.
          //
          // `id` es el autoincremental de la base local del cliente, y eso deja
          // de ser creciente en cuanto esa base se reemplaza: restaurar un
          // backup viejo, importar otra base, o rehacerle la DB a un cliente.
          // Los movimientos nuevos arrancan con ids MAS BAJOS que los ya
          // publicados, caen por debajo del cursor y se vuelven invisibles —
          // mientras los totales, que salen del user doc, siguen moviendose.
          // Es el peor sintoma posible: "la caja no se actualiza" pero los
          // numeros cambian. Medido en un caso real: 507 documentos, 496
          // visibles, 11 escondidos.
          //
          // La fecha no tiene ese problema y es ademas el orden que el operador
          // espera ver.
          const qNew = query(
            cashRef,
            orderBy("date", "asc"),
            startAt(oldestInitDoc)
          );
          // Obtener documentos iniciales
          const initialQuerySnapshot = await getDocs(qNew);
          const initialDocuments = [];

          // Qué ids ya tenemos cargados. Reemplaza a la comparación
          // `docData.id > last_id`, que arrastraba la misma suposición de que
          // el id siempre crece.
          const cargados = new Set();
          initialQuerySnapshot.forEach((doc) => {
            const docData = doc.data();
            cargados.add(String(docData.id));
            initialDocuments.push(docData);
          });

          dispatch(setDataCash(initialDocuments));

          unsubscribe = onSnapshot(qNew, (snapshot) => {
            snapshot.docChanges().forEach((change) => {
              const docData = change.doc.data();

              if (change.type === "added") {
                // El primer disparo de onSnapshot reentrega como "added" todo
                // lo que ya trajo getDocs: sin este filtro se duplicaría cada
                // movimiento y saldría un toast por cada uno.
                if (cargados.has(String(docData.id))) return;
                cargados.add(String(docData.id));
                dispatch(addDataCash(docData));

                toast.info(
                  "Nuevo movimiento de caja " +
                    formatCurrency(docData.value, true)
                );
              } else if (change.type === "modified") {
                // Un movimiento que cambió: el caso típico es corregirle la
                // forma de pago desde la caja del Desktop, que reescribe el
                // documento en el lugar.
                //
                // Antes este caso no existía —sólo se atendía "added"— así que
                // el cambio llegaba a Firestore y la tabla seguía mostrando lo
                // viejo hasta recargar la página. El listener de tickets sí los
                // manejaba; el de caja no.
                dispatch(updateDataCash(docData));
              } else if (change.type === "removed") {
                cargados.delete(String(docData.id));
                dispatch(removeDataCash(docData));
              }
            });
          });
        } else {
          // No hay datos aún (resync en curso). Listener temporal que espera el primer doc init.
          const qWait = query(
            cashRef,
            where("type", "==", "init"),
            orderBy("date", "asc"),
            limit(1)
          );
          unsubscribe = onSnapshot(qWait, (snapshot) => {
            if (snapshot.docs.length > 0) {
              // Llegaron datos de cash — re-ejecutar fetchDocuments completo
              if (unsubscribe) unsubscribe();
              fetchDocuments();
            }
          });
        }
      };

      fetchDocuments();

      return () => {
        // Detener la suscripción cuando el componente se desmonte
        if (unsubscribe) {
          unsubscribe();
        }
      };
    } catch (error) {
      alert("Error en ListenerDB: " + error);
    }
  }, [props.currentCompany.id, props.syncVersion, dispatch]);

  // / INOUT

  // useEffect(() => {
  //   if (!props?.currentCompany?.id) {
  //     return;
  //   }
  //   try {
  //     let unsubscribe6; // Declarar la variable en el ámbito superior
  //     const now = new Date();
  //     const thirtyDaysAgo = new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000);
  //     const thirtyDaysAgoString = formatDate(thirtyDaysAgo);
  //     console.log("thirtyDaysAgo", thirtyDaysAgo);
  //     console.log("thirtyDaysAgoString", thirtyDaysAgoString);

  //     const fetchDocuments = async () => {
  //       const inoutRef = collection(
  //         firestore,
  //         "users",
  //         props.currentCompany.id,
  //         "inout"
  //       );

  //       const q1111 = query(
  //         inoutRef,
  //         // where("date", ">=", thirtyDaysAgoString),
  //         orderBy("date", "desc"), // Ordena por "date" primero
  //         // orderBy("id", "asc"), // Luego, si es necesario, ordena por "id"
  //         limit(isMobile ? 250 : 250)
  //       );

  //       unsubscribe6 = onSnapshot(q1111, (snapshot) => {
          
  //         let count = 0; // Reiniciar el contador al recibir nuevos datos
  //         snapshot.docChanges().forEach((change) => {
  //           count++;
  //           if (change.type === "added") {
  //             const docData = change.doc.data();
  //             dispatch(addInout(docData));
  //           }
  //         });
  //         // alert("Se han recibido " + count + " nuevos registros de inout.");
  //       });
  //     };
  //     fetchDocuments();
  //     return () => {
  //       if (unsubscribe6) {
  //         unsubscribe6();
  //       }
  //     };
  //   } catch (error) {
  //     alert("Error en ListenerDB: " + error);
  //   }
  // }, [props.currentCompany.id, dispatch]);

  return (
    <ToastContainer
      limit={3}
      pauseOnHover={false}
      position="bottom-right"
      autoClose={3000}
      hideProgressBar
      newestOnTop
      closeOnClick
      theme="light"
      toastStyle={{
        borderRadius: "12px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        fontSize: "13px",
        padding: "12px 16px",
      }}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    currentCompany: state.companies.currentCompany,
    dataResumeCash: state.data.dataResumeCash,
    logins: state.data.logins,
    syncVersion: state.data.syncVersion,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTicketsStats: (ticketsStats) => dispatch(setTicketsStats(ticketsStats)),
    fetchDataResumeCash: () => dispatch(fetchDataResumeCash()),
    setLogins: (logins) => dispatch(setLogins(logins)),
    fetchOpenedTickets: () => dispatch(fetchOpenedTickets()),
    setOpenedTickets: (tickets) => dispatch(setOpenedTickets(tickets)),
    setCC: (cc) => dispatch(setCC(cc)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListenerDB);
